export default () => {
  window.zE('webWidget', 'open');
};
